import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { hasPermissionKey } from "utils/permissionUtils";

const ProtectedRoute = ({ children, requiredPermission }) => {
  const [hasAccess, setHasAccess] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    try {
      const access = hasPermissionKey(requiredPermission);
      setHasAccess(access);

      if (!access) {
        toast.error("You don't have permission to access this page");
      }
    } catch (error) {
      console.error("Error checking permissions:", error);
      setHasAccess(false);
      toast.error("You don't have permission to access this page");
    } finally {
      setIsLoading(false);
    }
  }, [requiredPermission, location.pathname]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!hasAccess) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
